import angular, { IQService, IPromise } from 'angular'
import moment from 'moment'
import templateUrl from './events-coordination-review-container.component.html'
import './events-coordination-review-container.less'
import { sortIcdOfficeByOwner, IcdOfficeService } from '../../core/services/data-services/icd-office.service';
import { EditScheduleEventModal } from '../events-scheduling/shared/edit-schedule-event.component.js';
import { ScheduleEventOfficeAssignmentEditorModal } from '../events-scheduling/shared/schedule-event-office-assignment-editor.component.js';
import { SiteModuleEnum } from '../../core/enum/site-module';
import { DivisionService, EmployeeService, EventHostService, ScheduleEventService } from '../../core/services';
import { UtilityService } from '../../core/services/utility.service';

export const EventsCoordinationReviewComponent = {
    controller: EventsCoordinationReviewController,
    templateUrl
}

const recentsLocalStorageKey = "apexEventsSchedulingRecentIcds";

function EventsCoordinationReviewController($uibModal, $q: IQService, apexApiUrl: string,
    divisionService: DivisionService,
    employeeService: EmployeeService, eventHostService: EventHostService,
    icdOfficeService: IcdOfficeService, scheduleEventService: ScheduleEventService,
    utilityService: UtilityService) {

    'ngInject'
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.$onInit = $onInit;
    vm.addNewEvent = addNewEvent;
    vm.deleteSchedule = deleteSchedule;
    vm.deleteScheduleEvent = deleteScheduleEvent;
    vm.divisions = [];
    vm.editSchedule = editSchedule;
    vm.editScheduleEvent = editScheduleEvent;
    vm.eventHosts = [];
    vm.filters = { view: 'schedule' };
    vm.icdOffices = [];
    vm.loaded = false;
    vm.onChangeCalendar = onChangeCalendar;
    vm.onChangeDivision = onChangeDivision;
    vm.onChangeFilters = onChangeFilters;
    vm.onChangePage = onChangePage;
    vm.onChangeSearchOffice = onChangeSearchOffice;
    vm.onChangeView = onChangeView;
    vm.onClickTimeSlot = onClickTimeSlot;
    vm.onDoubleClickTimeSlot = onDoubleClickTimeSlot;
    vm.onDropIntoSchedule = onDropIntoSchedule;
    vm.onDeleteTimeSlot = onDeleteTimeSlot;
    vm.pageNumber = 1;
    vm.pageSize = 30;
    vm.pristineIcdOffices = [];
    vm.recentIcdOffices = [];
    vm.scheduleEvents = [];
    vm.scheduleEventStatuses = [
        { Name: "Pending", StatusID: 1 },
        { Name: "Accepted", StatusID: 2 },
        { Name: "Rejected", StatusID: 3 },
        { Name: "Unassigned", StatusID: 4 }
    ];
    vm.calendar = {
        mode: "week",
        startDate: moment().startOf("isoWeek").toDate(),
        endDate: moment().endOf("isoWeek").toDate()
    };
    vm.scheduleActions = [{
        label: function (schedule) {
            return "Assign/Unassign";
        },
        enabled: function (schedule) {
            return true;
        },
        action: onAssignScheduleEvent
    }];

    function $onInit() {
        initailizePage();
    }


    function initailizePage() {

        vm.loaded = false;
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity();
        const loadInitialData = identity.then(identity => divisionService.retrieveDivisions({
            ModuleID: SiteModuleEnum.EventsCoordination,
            ModuleAdminID: identity.EmployeeID
        }))
            .then(function (divisions) {
                vm.divisions = divisions.sort((a, b) => a.Name < b.Name ? -1 : 1);
                vm.filters.division = vm.divisions[0]
                return vm.filters.division;
            })
            .then(function () {
                return loadEventHosts();
            })
            .then(function () {
                return loadScheduleEvents();
            })
            .then(function () {
                return loadIcdOffices();
            }).then(function () {
                return loadRecentIcdOffices();
            });

        loadInitialData
            .then(function () {
                vm.loaded = true;
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function loadRecentIcdOffices() {
        return $q.resolve()
            .then(() => {
                return JSON.parse(localStorage.getItem(recentsLocalStorageKey) || "[]");
            })
            .catch(() => []) // Non-crucial
            .then(allRecents => {
                updateRecentIcdOffices(allRecents, vm.icdOffices);
            });
    }

    function loadEventHosts() {
        if (!vm.filters.division) {
            vm.eventHosts = [];
            return $q.resolve(vm.eventHosts);
        }

        return eventHostService.retrieveEventHosts({ DivisionID: vm.filters.division.Id })
            .then(function (eventHosts) {
                vm.eventHosts = eventHosts.map(eventHost => {
                    eventHost.Text = [
                        eventHost.HostName,
                        eventHost.HostNumber ? `#${eventHost.HostNumber}` : "",
                        eventHost.HostLocationName ? `(${eventHost.HostLocationName})` : ""
                    ].filter(p => p && p.trim())
                        .join(" ");
                    return eventHost;
                }).sort((p, q) => p.Text < q.Text ? -1 : 1);
                return eventHosts;
            });
    }

    function loadIcdOffices() {
        if (!vm.filters.division) {
            vm.icdOffices = [];
            return $q.resolve(vm.icdOffices);
        }
        return icdOfficeService.retrieveIcdOffices({ divisionID: vm.filters.division.Id }).then(function (offices) {
            vm.icdOffices = offices.sort(sortIcdOfficeByOwner);
            vm.icdOffices.forEach(mapOfficeLogo);
            vm.pristineIcdOffices = angular.copy(vm.icdOffices);
            return vm.icdOffices;
        });
    }

    function mapOfficeLogo(office) {
        office.CompanyLogo = apexApiUrl + "/corporations/" + office.IcdCorporationId + "/logo";
    }

    function loadScheduleEvents() {
        if (!vm.filters.division) {
            vm.scheduleEvents = [];
            return $q.resolve(vm.scheduleEvents);
        }

        const param = generateQueryParameter();
        param.PageSize = vm.pageSize;
        return scheduleEventService.retrieveScheduleEventsPage(vm.pageNumber - 1, param)
            .then(function (page) {
                vm.page = page;
                vm.scheduleEvents = page.Entities.map(mapScheduleEvent);
                vm.pristineScheduleEvents = angular.copy(vm.scheduleEvents)
                return vm.scheduleEvents
            })
    }

    function mapScheduleEvent(scheduleEvent) {
        const eventNames = [
            // RS schedules are haphazardly named, so show specific fields
            // depending on the schedule event data available.
            scheduleEvent.HostLocationName
                ? `${scheduleEvent.HostName} (${scheduleEvent.HostLocationName})`
                : scheduleEvent.HostName,
            scheduleEvent.Program
        ].filter(p => p && p.trim())
            .join(" - ");

        const timeSlots = breakIntoTimeSlots(scheduleEvent);

        const officeTimeSlots = [];
        if (scheduleEvent.ScheduleEventOffices.length > 0) {
            scheduleEvent.ScheduleEventOffices.forEach(function (office) {
                const isAssigned = office.AssignedStatus !== "Unassigned";
                const description = isAssigned ? office.OwnerName + " - " + " (" + office.IcdOfficeName + ") " + office.AssignedStatus : office.AssignedStatus;
                const slots = timeSlots.map(function (timeSlot) {
                    return createTimeSlot(timeSlot, description, office);
                });
                officeTimeSlots.push(...slots);
            });
        } else {

            const slots = timeSlots.map(function (timeSlot) {
                return createTimeSlot(timeSlot, "Unassigned");
            });
            officeTimeSlots.push(...slots);
        }
        const event = {
            id: scheduleEvent.ScheduleEventID,
            name: eventNames,
            description: moment(scheduleEvent.StartDate).format("MM-DD-YYYY") + " - " + moment(scheduleEvent.EndDate).format("MM-DD-YYYY"),
            readOnly: false,
            editable: true,
            assigned: officeTimeSlots.length > 0,
            deletable: true,
            allowDrop: true,//Allow dropping to the whole schedule row
            timeSlots: officeTimeSlots
        };
        return event;
    }

    function createTimeSlot(timeSlot, description, office?) {
        const style: any = office ? getScheduleStyle(office) : {};
        if (timeSlot.isOffDay) {
            style.backgroundColor = "#f44242";
            style.borderColor = "#f44242";
            style.color = "#FFFFFF";
        }
        return {
            ...timeSlot,
            allDay: true,
            description: timeSlot.isOffDay ? "Off Day" : description,
            draggable: false,
            style: style,
            deletable: true,
            office: {
                IcdOfficeID: office ? office.IcdOfficeID : null
            }
        }

    }

    function getScheduleStyle(schedule) {
        const style: any = {};
        switch (schedule.AssignedStatus) {
            case "Pending":
                style.backgroundColor = "#F0AD4E";
                style.borderColor = "#EEA236";
                style.color = "#FFFFFF";
                break;
            case "Accepted":
                style.backgroundColor = "#2764AB";
                style.borderColor = "#215490";
                style.color = "#FDFDFD";
                break;
            case "Rejected":
                style.backgroundColor = "#CD5C5C";
                style.borderColor = "#CD5C5C";
                style.color = "#FFFFFF";
                break;
        }
        return style;
    }

    function generateQueryParameter(): any {
        const params: any = {
            StartDate: vm.calendar.startDate,
            EndDate: vm.calendar.endDate,
            DivisionID: vm.filters.division.Id,
            AssignedStatus: vm.filters.assignedStatus
        }
        if (vm.filters.office) {
            params.AssignedIcdOfficeIDs = [vm.filters.office.Id];
        }
        if (vm.filters.eventHost) {
            params.EventHostID = vm.filters.eventHost.EventHostID;
        }
        return params;
    }

    function onDropIntoSchedule(schedule, payload) {
        addIcdToRecents(payload.office.Id);
        const request = getAssignmentPatchRequest([payload.office.Id], []);
        patchScheduleEvent(schedule, request);
    }

    function addIcdToRecents(icCofficeID) {
        // Push the given corporation to the front of the recents list.
        /** @type {Array}  */
        let allRecents = JSON.parse(localStorage.getItem(recentsLocalStorageKey) || "[]");
        // Remove and add back to the front of the list.
        allRecents = allRecents.filter(p => p !== icCofficeID);
        allRecents.unshift(icCofficeID)
        localStorage.setItem(recentsLocalStorageKey, JSON.stringify(allRecents));
        loadRecentIcdOffices();
    }

    function editSchedule(schedule) {
        editScheduleEvent(schedule);
    }

    function deleteSchedule(schedule) {
        if (!confirm("The schedule will be deleted and/or unassigned.")) {
            return;
        }
        deleteScheduleEvent(schedule);
    }

    function onDoubleClickTimeSlot(event) {

    }

    function onClickTimeSlot(event) {

    }

    function onDeleteTimeSlot(schedule, timeSlot) {
        const office = vm.icdOffices.filter(function (office) {
            return office.Id === timeSlot.office.IcdOfficeID
        })[0];
        if (office) {
            if (!confirm(`${office.IcdCorporationName} will be unassigned from the schedule and all "
                + "of their reps will be unassigned. Are you sure?`)) {
                return;
            }
            const request = getAssignmentPatchRequest([], [timeSlot.office.IcdOfficeID]);
            patchScheduleEvent(schedule, request);
        }
    }

    function onChangeCalendar(calendar) {
        vm.calendar.startDate = calendar.startDate;
        vm.calendar.endDate = calendar.endDate;
        utilityService.showLoadingUntilResolved(loadScheduleEvents())
    }

    function onChangeSearchOffice() {
        vm.icdOffices = vm.pristineIcdOffices.filter(function (office) {
            return utilityService.containsInvariant(office.OwnerName, vm.filters.office) ||
                utilityService.containsInvariant(office.IcdCorporationName, vm.filters.office)
        });
        loadRecentIcdOffices();
    }

    function onChangeDivision() {
        vm.pageNumber = 1;
        reloadPageData()
            .then(() => loadEventHosts());
    }


    function onChangeView() {
        vm.pageNumber = 1;
        reloadPageData();
    }

    function onChangePage() {
        reloadPageData();
    }

    function onChangeFilters() {
        vm.pageNumber = 1;
        utilityService.showLoadingUntilResolved(
            loadScheduleEvents()
        )
    }

    function reloadPageData(): IPromise<void> {
        if (vm.filters.view === 'schedule') {
            utilityService.showLoading();
            return loadIcdOffices()
                .then(function () {
                    return loadRecentIcdOffices();
                })
                .then(function () {
                    return loadScheduleEvents();
                }).catch(function (ex) {
                    console.error(ex);
                    alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
                })
                .then(function () {
                    vm.loaded = true;
                    utilityService.hideLoading();
                });
        } else {
            return $q.resolve();
        }

    }


    function addNewEvent() {
        showEditForm();
    }

    function editScheduleEvent(schedule) {
        utilityService.showLoading();
        scheduleEventService.retrieveScheduleEvent(schedule.id)
            .then(function (scheduleEvent) {
                utilityService.hideLoading();
                showEditForm(scheduleEvent);
            })
            .catch(function (ex) {
                alert("Edit event failed " + (ex.statusText || ex))
            });

    }

    function showEditForm(scheduleEvent?) {
        return $uibModal.open({
            ...EditScheduleEventModal,
            resolve: {
                scheduleEvent: () => scheduleEvent ? angular.copy(scheduleEvent) : {},
                eventHosts: () => vm.eventHosts.map(host => ({
                    ...host
                })),
                divisionID: () => vm.filters.division.Id,
            }
        })
            .result
            .then(function (scheduleEvent) {
                utilityService.showLoadingUntilResolved($q.all([loadScheduleEvents(), loadEventHosts()]));
            });
    }

    function onAssignScheduleEvent(schedule) {
        utilityService.showLoading();
        scheduleEventService.retrieveScheduleEvent(schedule.id)
            .then(function (scheduleEvent) {
                utilityService.hideLoading();
                showAssignmentForm(scheduleEvent);
            })
            .catch(function (ex) {
                utilityService.hideLoading();
                alert("Edit event failed " + (ex.statusText || ex))
            });
    }

    function getAssignmentPatchRequest(assignedOfficeIDs, unAssignedOfficeIDs) {
        return {
            AssignIcdOffice: {
                AssignedIcdOfficeIDs: assignedOfficeIDs,
                UnassignedIcdOfficeIDs: unAssignedOfficeIDs
            }
        };
    }

    function showAssignmentForm(scheduleEvent) {

        return $uibModal.open({
            ...ScheduleEventOfficeAssignmentEditorModal,
            resolve: {
                scheduleEvent: () => scheduleEvent ? angular.copy(scheduleEvent) : {},
                divisionID: () => vm.filters.division.Id,
            }
        }).result
            .then(function (scheduleEvent) {
                utilityService.showLoadingUntilResolved(loadScheduleEvents())
            });
    }

    function patchScheduleEvent(schedule, request) {
        utilityService.showLoading();
        scheduleEventService.patchScheduleEvent(schedule.id, request)
            .then(function () {
                utilityService.hideLoading();
                utilityService.showLoadingUntilResolved(loadScheduleEvents())
            }).catch(function (ex) {
                utilityService.hideLoading();
                console.error(ex);
                alert("Assignment failed " + utilityService.getExceptionMessage(ex));
            })
    }

    function deleteScheduleEvent(schedule) {
        utilityService.showLoading();
        scheduleEventService.deleteScheduleEvent(schedule.id)
            .catch(function (ex) {
                alert("Deleting event host failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
                utilityService.showLoadingUntilResolved(
                    utilityService.alertOnError(loadScheduleEvents(), "Loading page failed"));
            });
    }

    function updateRecentIcdOffices(allRecents, offices) {
        const dict = offices.reduce((dict, icd) => {
            dict[icd.Id] = icd;
            return dict;
        }, {});
        vm.recentIcdOffices = allRecents.map(p => dict[p])
            .filter(p => p); // Ignore offices that weren't in the lookup
    }
}

/**
 * Break down the given schedule event into a list of continuous time slots.
 * @param {any} scheduleEvent The schedule event to be broken down.
 */
function breakIntoTimeSlots(scheduleEvent) {
    const startDate = moment(scheduleEvent.StartDate).startOf("day");
    const endDate = moment(scheduleEvent.EndDate).endOf("day");

    const offDates = Array.from(scheduleEvent.OffDates).sort((a, b) => a < b ? -1 : 1);
    const timeSlots = [];
    let startTime = startDate;
    for (const offDate of offDates) {
        if (startTime.isBefore(offDate, "day")) {
            timeSlots.push({
                startDateTime: startTime.toDate(),
                endDateTime: moment(offDate).add(-1, "day").endOf("day").toDate(),
                isOffDay: false
            });
        }
        timeSlots.push({
            startDateTime: moment(offDate).startOf("day").toDate(),
            endDateTime: moment(offDate).endOf("day").toDate(),
            isOffDay: true
        });
        startTime = moment(offDate).add(1, "day");
    }
    if (startTime.isBefore(endDate)) {
        timeSlots.push({
            startDateTime: startTime.startOf("day").toDate(),
            endDateTime: endDate.toDate(),
            isOffDay: false
        })
    }
    return timeSlots;
}
